const KEY = 'dar.admin.reloadedAt';

/**
 * Reloads onto the current deploy: a tab opened before an update asks for page
 * files that the new deploy no longer has. At most once per 30 s, so a real bug
 * can't loop. Returns false when it did not reload.
 */
export function reloadOnce(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 30_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

/** Wraps a lazy page import: if its file is gone after a deploy, reload instead of showing an error. */
export async function importOrReload<T>(load: () => Promise<T>): Promise<T> {
  try {
    return await load();
  } catch (e) {
    if (reloadOnce()) return new Promise<T>(() => {});
    throw e;
  }
}
